// removed by extract-text-webpack-plugin
module.exports = {"labelContainer":"CarType-labelContainer-46687415","textContainer":"CarType-textContainer-be59ec4c","label":"CarType-label-e07fca9f","results":"CarType-results-13c85baa","selected":"CarType-selected-e2969ec7"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/CarType.scss
// module id = 784
// module chunks = 0